import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Form, Formik, Field } from 'formik';
import Spinner from 'web/components/Spinner';

import * as moment from 'moment';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';

import {  useDispatch } from 'react-redux';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import AlertModal from 'web/components/AlertModal';
import TextArea from "web/components/form-elements/TextArea";

import TimePickerInput from 'web/components/form-elements/TimePickerInput';
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from 'web/components/utils/cancelOrderUtils';

import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';

import DatePicker from 'web/components/form-elements/DatePicker';

import RadioButton from 'web/components/form-elements/RadioButton';

import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components'


import { Container, Body, TrackBox } from './cancelModalStyled'
export default ({ isOpen, toggle, title, content, link, onClickHander, requestType, modalCallBackFun, cancelOrderId, items }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);

  const [message, setMessage] = useState('')

  const lessThanTwoDay = (items, date) => {
    if (items.rescheduleOrder) {
      if (items.userType === "BUYER") {
        date = items.rescheduleOrder.buyerRescheduledDate
      } else {
        date = items.rescheduleOrder.sellerRescheduledDate
      }
    }

    let resolvedWithExchange = false;
    let exchangeClaimList = [];
    let exchangeClaimListTotalQuantity = 0;
    if (items.claimDetails && items.claimDetails.length > 0) {
      exchangeClaimList = items.claimDetails.filter(
        (val) =>
          val.returnInstruction &&
          (val.returnInstruction.includes("Exchange") ||
            val.returnInstruction.includes("Redeliver"))
      );
      if (exchangeClaimList.length > 0) {
        resolvedWithExchange = true;
        exchangeClaimListTotalQuantity =
          (exchangeClaimList[exchangeClaimList.length - 1]
            .claimQuality &&
            exchangeClaimList[exchangeClaimList.length - 1]
              .claimQuality) +
          (exchangeClaimListTotalQuantity +
            exchangeClaimList[exchangeClaimList.length - 1]
              .claimQuantity);
      }
    }
    if (resolvedWithExchange) {
      date = exchangeClaimList[exchangeClaimList.length - 1].reDeliveryOrPickupDate
    }
    let setState = localStorage.getItem('state')
    let nDate = new Date().toLocaleString('en-US', {
      timeZone: 'US/' + timeZoneFun(setState)
    });
    let MILLIS_PER_DAY = 48 * 60 * 60 * 1000
    let currentDate = new Date(nDate)
    let wkdy = new Date(currentDate.setHours(currentDate.getHours())).getDay();

    if (wkdy === 5) {
      currentDate = new Date(new Date(currentDate).setHours(new Date(currentDate).getHours() + 48))
    }
    else if (wkdy === 6) {
      currentDate = new Date(new Date(currentDate).setHours(new Date(currentDate).getHours() + 48))
    }
    else if (wkdy === 7) {
      currentDate = new Date(new Date(currentDate).setHours(new Date(currentDate).getHours() + 24))
    }
    let createdDate = new Date(date)
    if (createdDate < currentDate) {
      return false;
    }
    let Difference_In_Time = createdDate.getTime() - currentDate.getTime();
    let Difference_In_Hours = Math.floor(Difference_In_Time / (1000 * 3600));
    if (Difference_In_Hours <= 48) {
      return false
    } else {
      return true
    }
  }

  const lessThanOneDay = (items, date) => {
    if (items.rescheduleOrder) {
      if (items.userType === "BUYER") {
        date = items.rescheduleOrder.buyerRescheduledDate
      } else {
        date = items.rescheduleOrder.sellerRescheduledDate
      }
    }
    let resolvedWithExchange = false;
    let exchangeClaimList = [];
    let exchangeClaimListTotalQuantity = 0;
    if (items.claimDetails && items.claimDetails.length > 0) {
      exchangeClaimList = items.claimDetails.filter(
        (val) =>
          val.returnInstruction &&
          (val.returnInstruction.includes("Exchange") ||
            val.returnInstruction.includes("Redeliver"))
      );
      if (exchangeClaimList.length > 0) {
        resolvedWithExchange = true;
        exchangeClaimListTotalQuantity =
          (exchangeClaimList[exchangeClaimList.length - 1]
            .claimQuality &&
            exchangeClaimList[exchangeClaimList.length - 1]
              .claimQuality) +
          (exchangeClaimListTotalQuantity +
            exchangeClaimList[exchangeClaimList.length - 1]
              .claimQuantity);
      }
    }
    if (resolvedWithExchange) {
      date = exchangeClaimList[exchangeClaimList.length - 1].reDeliveryOrPickupDate
    }
    let setState = localStorage.getItem('state')
    let nDate = new Date().toLocaleString('en-US', {
      timeZone: 'US/' + timeZoneFun(setState)
    });
    let MILLIS_PER_DAY = 24 * 60 * 60 * 1000
    let currentDate = new Date(nDate)
    let createdDate = new Date(date)
    if (createdDate < currentDate) {
      return false;
    }

    let Difference_In_Time = createdDate.getTime() - currentDate.getTime();
    let Difference_In_Hours = Math.floor(Difference_In_Time / (1000 * 3600));
    if (Difference_In_Hours <= 24) {
      return false
    } else {
      return true
    }
  }

  const lessThanSixHours = (date, items) => {
    let currentTime;
    let setState = localStorage.getItem('state')

    let nDate = new Date().toLocaleString('en-US', {
      timeZone: 'US/' + timeZoneFun(setState)
    });
    let currentDate = new Date(nDate)
    let createdDate = new Date(date)

    let Difference_In_Time = createdDate.getTime() - currentDate.getTime();
    let Difference_In_Hours = Math.floor(Difference_In_Time / (1000 * 3600));

    if (createdDate < currentDate) {
      return true;
    }
    if (Difference_In_Hours > 6) {
      return false;
    } else {
      return true;
    }

  }

  let defalutRadio = ''
  let rescheduleOrderFlag = false
  if ((items.orderDetails.material === "OTHER" || items.orderDetails.dimension.height) && items.userType === "BUYER") {
    defalutRadio = 'RescheduleOrder'
    rescheduleOrderFlag = true
  } else {
    if (items.userType === "BUYER" && lessThanOneDay(items, items.contactInfo.requestedDate) === false) {
      if (lessThanSixHours(items.contactInfo.requestedDate, items) === false) {
        defalutRadio = ''
      } else {
        defalutRadio = 'RescheduleOrder'
        rescheduleOrderFlag = true
      }

    } else if (items.userType === "SELLER" && lessThanTwoDay(items, items.contactInfo.requestedDate) === false) {
      defalutRadio = ''
    } else {
      defalutRadio = ''
    }
  }

  const [dateTimeFlag, setDateTimeFlag] = useState(false)
  let INITIAL_VALUES = {
    orderType: defalutRadio,
    cancelComment:""
  }

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);

  const cancelOrderArr = [
    {
      value: 'CancelOrder',
      label: 'Cancel Order',
    }
  ];
  let patternArr = [
    {
      value: 'CancelOrder',
      label: 'Cancel Order',
    },
    {
      value: 'RescheduleOrder',
      label: 'Reschedule Order',
    }
  ];
   if ((items.orderDetails.material === "OTHER" || items.orderDetails.dimension.height) && items.userType === "BUYER") {
    patternArr = [
      {
        value: 'RescheduleOrder',
        label: 'Reschedule Order',
      }
    ];
  }

  const [cancelBtnFlag, setCancelBtnFlag] = useState(false)

  const dateTimeFun = () => {
    return <>{(dateTimeFlag || rescheduleOrderFlag) && 
    <Formik
      initialValues={getPostInitialValues(items)}
      validationSchema={VALIDATION_SCHEMA()}
      onSubmit={(values) => {
      }}>
      {(props) => {
        const {
          isValid,
          dirty,
          values,
          errors,
          touched,
          setFieldValue,
        } = props;

        return (
          <>
            <Form>
              <div className='row mx-0 my-3'>
                <div className='col-12'>
                  <div className='row'>
                    <div className='col-md-5 col-sm-5 mb-2'>
                      <DatePicker
                        name='cancelDate'
                        userType={items.userType}
                        type="ReschduleDatesDisabled"
                        response={items}
                        selectedDate={items.contactInfo.requestedDate}
                        placeholderText='Bid close time&#42;'
                      />
                    </div>
                    <div className='col-md-7 col-sm-7' style={{ display: 'flex', alignItems: 'center' }}>
                      {/* <TimePicker
                          name='requestedStartTime'
                          type='time'
                          startTime={null}
                          showErrorMessages={true}
                          props={props}
                        /> */}
                      <TimePickerInput
                        name='requestedStartTime'
                        type='time'
                        startTime={null}
                        showErrorMessages={true}
                        props={props}
                      />
                      <span className='toStyle' style={{ padding: '0 15px', 'margin-top': '-28px' }}>To</span>
                      <TimePickerInput
                        name='requestedEndTime'
                        type='time'
                        endTime={null}
                        showErrorMessages={true}
                        props={props}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-3 py-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', marginBottom: '5px' }}>
                <Button
                  type='app-green-button submitBtn'
                  handleClick={() => {
                    modalCallBackFun(items.id, "RESCHEDULE", props)
                    // if(props?.values.comment){
                    //   modalCallBackFun(items.id, "RESCHEDULE", props)
                    // }               
                  }}
                >
                  DONE
                </Button></div>
            </Form>
          </>
        );
      }}
    </Formik>}</>
  }



  const getStateCurrentTime = () => {
    let nDate;
    let currentTime;
    let setState = localStorage.getItem('state')
 
    nDate = new Date().toLocaleString('en-US', {
      timeZone: 'US/' + timeZoneFun(setState)
    });
    let getTime = new Date(nDate)
  }


  const rescheduleRadio = (flag, userType) => {
    if ((items.orderDetails.material === "OTHER" || items.orderDetails.dimension.height)) {
        if(items.userType === "BUYER"){
          patternArr = [
            {
              value: 'RescheduleOrder',
              label: 'Reschedule Order',
            }
          ];
        }else{
          patternArr = [
            {
              value: 'CancelOrder',
              label: 'Cancel Order',
            },
            {
              value: 'RescheduleOrder',
              label: 'Reschedule Order',
            }
          ];
        }
    }
    
    return <>   
    {patternArr &&
      patternArr.map((value, index) => (
        <div className='col-6' key={index}>
          <Field
            component={RadioButton}
            name='orderType'
            id={value.value}
            defaultValue={patternArr[0].value}
            onSelect={(e) => {
              if (e.target.value !== "CancelOrder") {
                setDateTimeFlag(!dateTimeFlag)
                setCancelBtnFlag(false)
              } else {
                setCancelBtnFlag(true)
                setDateTimeFlag(false)
              }
            }}
            label={value.label}
          />
        </div>
      ))}
      </>
  }
  const cancelOrderRadio = () => {
    return <>{cancelOrderArr &&
      cancelOrderArr.map((value, index) => (
        <div className='col-6' key={index}>
          <Field
            component={RadioButton}
            name='orderType'
            id={value.value}
            defaultValue={cancelOrderArr[0].value}
            onSelect={(e) => {
              if (e.target.value !== "CancelOrder") {
                setDateTimeFlag(!dateTimeFlag)
                setCancelBtnFlag(false)
              } else {
                setCancelBtnFlag(true)
                setDateTimeFlag(false)
              }
            }}
            label={value.label}
          />
        </div>
      ))}</>
  }

  const requestedDateTime = (items) => {
    let startTime = items.contactInfo.requestedStartTime.split(":");
    let hour = startTime[0];
    let minute = startTime[1];

    let endTime = items.contactInfo.requestedEndTime.split(":");
    let endHour = endTime[0];
    let endMinute = endTime[1];
    return <>&nbsp;&nbsp;
    <span>{hour + ":" + minute}</span>
      &nbsp;
      -
      &nbsp;
    <span>{endHour + ":" + endMinute}</span>
    </>
  }

  let resolvedWithExchange = false;
  let exchangeClaimList = [];
  let exchangeClaimListTotalQuantity = 0
  if (items.claimDetails && items.claimDetails.length > 0) {
    exchangeClaimList = items.claimDetails.filter(
      (val) =>
        val.returnInstruction &&
        (val.returnInstruction.includes("Exchange") ||
          val.returnInstruction.includes("Redeliver"))
    );
    if (exchangeClaimList.length > 0) {
      resolvedWithExchange = true
      exchangeClaimListTotalQuantity = (exchangeClaimList[exchangeClaimList.length - 1].claimQuality && exchangeClaimList[exchangeClaimList.length - 1].claimQuality) + (exchangeClaimListTotalQuantity + exchangeClaimList[exchangeClaimList.length - 1].claimQuantity)
    }
  }
  return (<>
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        fullscreen='fullscreen'
        className="cancelOrderModal"
        style={{ maxWidth: '570px' }}
      >
        <Container>
          <div className='header'>
            <Button handleClick={() => {
              setCancelBtnFlag(false)
              setDateTimeFlag(false)
              toggle(!isOpen)

            }} >
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            {(items.orderDetails.material === "OTHER" || items.orderDetails.dimension.height) && items.userType === "BUYER" ?
              <h3 style={{ 'text-align': 'center', 'margin-top': '7px', padding: '0 32px' }}>Reschedule Order</h3>
              :
              <>
               <h3 style={{ 'text-align': 'center', 'margin-top': '7px', padding: '0 32px' }}>Cancel or Reschedule Order</h3>
               {lessThanSixHours(items.contactInfo.requestedDate, items) === true ? <p style={{ 'padding': '16px', 'text-align': 'justify' }}>{`The order is scheduled to be ${items && items.contactInfo && items.contactInfo.type === 'PICKUP' ? 'picked up' : 'delivered'} within 6 business hour so it cannot be canceled or rescheduled via the portal.`}</p>: <p style={{ 'padding': '16px', 'text-align': 'justify' }}>{`Select “Cancel Order” or “Reschedule Order” below. If you choose to cancel within one business day of the ${items && items.contactInfo && items.contactInfo.type === 'PICKUP' ? 'pickup' : 'delivery'} date, a fee will be assessed of $100. If you opt to reschedule, the other party will need to confirm the requested rescheduled date for the delivery date to change.`}</p>}
              </>
            }

          </div>
          <ModalBody>
            {loaderVisible && <Spinner />}
            <Formik
              initialValues={INITIAL_VALUES}
              onSubmit={(values) => {
              }}>
              {(props) => {
                const {
                  isValid,
                  dirty,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                } = props;
                return (
                  <>
                    <Form>
                      <Container>
                        <Body>
                          <RowGroup>
                            <div className="mx-0 px-3">
                              <p>
                                <span className="bold">Requested Date: </span> {resolvedWithExchange ? moment(
                                  exchangeClaimList[
                                    exchangeClaimList.length - 1
                                  ].reDeliveryOrPickupDate
                                ).format(FORMAT) : items.contactInfo.requestedDate === null ? <span>NA</span> : <span>{moment(items.contactInfo.requestedDate).format(FORMAT)}</span>}
                                <span>{requestedDateTime(items)}</span>
                              </p>
                            </div>
                            {requestType !== "REJECTED" ? <div className="row mx-0 mt-3 mb-3 px-3">
                              {items.userType === "BUYER" && lessThanOneDay(items, items.contactInfo.requestedDate) === true ?
                                <>{lessThanSixHours(items.contactInfo.requestedDate, items) === true ? <p>Please contact a PalletTrader admin for further assistance at <a style={{ 'color': 'blue' }}>1-877-777-7495</a> or by emailing <a style={{ 'color': 'blue' }}>support@pallettrader.com</a>.</p> : rescheduleRadio()}</>
                                :
                                <>{items.userType === "SELLER" && lessThanTwoDay(items, items.contactInfo.requestedDate) === true ?
                                  <>
                                    {lessThanSixHours(items.contactInfo.requestedDate, items) === true ? <p>Please contact a PalletTrader admin for further assistance at <a style={{ 'color': 'blue' }}>1-877-777-7495</a> or by emailing <a style={{ 'color': 'blue' }}>support@pallettrader.com</a>.</p>
                                      : <>{rescheduleRadio(false)}
                                      </>}</>
                                  :
                                  lessThanSixHours(items.contactInfo.requestedDate, items) === true ?
                                    <p>Please contact a PalletTrader admin for further assistance at <a style={{ 'color': 'blue' }}>1-877-777-7495</a> or by emailing <a style={{ 'color': 'blue' }}>support@pallettrader.com</a>.</p> :
                                    rescheduleRadio(false, items.userType)}</>
                              }
                              {/* {rescheduleRadio(false, items.userType)} */}
                              {cancelBtnFlag && <>
                                <div style={{"width": "100%"}}>
                                  <div className='col-12'>
                                    <h5 style={{"text-align": "left","font-size": "16px", "margin-bottom":"10px"}}>Add Comment<span className="star">&#42;</span></h5>
                                    <TextArea
                                      name='comment'
                                      maxLength='200'
                                      showErrorMessages={true}
                                    />
                                  </div>
                                </div>
                                <div className="py-2 px-3">
                                  <Button
                                    type='app-green-button submitBtn'
                                    disabled={props?.values.comment?false:true}
                                    handleClick={() => {
                                      modalCallBackFun(items.id, "CANCELLED", "", props?.values.comment)
                                    }}>
                                    Done
                                  </Button>
                                </div>
                              </>}
                            </div> : <TrackBox><Button
                              type='app-green-button submitBtn'
                              handleClick={() => {
                                modalCallBackFun(items.id, "REJECTEDORDER", '')
                              }}>
                              Done
                            </Button></TrackBox>
                            }
                            
                           {/* {dateTimeFun()} */}
                           {items.userType === "BUYER" && lessThanOneDay(items, items.contactInfo.requestedDate) === true && lessThanSixHours(items.contactInfo.requestedDate, items) === false ?
                              <>{dateTimeFun()}</> : <>{items.userType === "SELLER" && lessThanTwoDay(items, items.contactInfo.requestedDate) === true ? <>{dateTimeFun()}</> : lessThanSixHours(items.contactInfo.requestedDate, items) === false ? <>{dateTimeFun()}</> : ''}</>}
                          </RowGroup>
                        </Body>
                      </Container>
                    </Form>
                  </>
                )
              }}
            </Formik>

          </ModalBody>
        </Container>
      </Modal>
    </div>

    <AlertModal
      isOpen={modal}
      toggle={toggleModal}
      title={title}
      content={modalContent}
      link={modalLink}
    />
  </>
  );
};


const RowGroup = styled.div`
        text-align: left;
        margin: 10px 0;
  .bold {
          font-family: "latobold";
        color: #000 !important;
        font-size:17px !important;
      }
  .timmer{
          display: flex;
      }
  .condition {
          font-style: italic;
        font-size: 14px;
        color: #930000;
    span {
          padding-left: 10px;
  position: relative;
      ::before {
          content: '*';
display: block;
position: absolute;
left: 0;
  }
      a {
          color: #0bb4ff;
        text-decoration: underline;
      }
    }
  }
`